/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { entityService } from './services';

const pathname = '/steps';

export const StepApi = {
  find: async (option: FindForStep = {}) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkBeforeDelete: async (id: string) => {
    const url = `${pathname}/${id}/check-before-delete`;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FindForStep {
  page?: number;
  take?: number;
  select?: string[];
  order?: any;
  where?: any;
}
